import { Navigate, useLocation } from "react-router-dom";

export interface RedirectKeepingSearchProps {
  to: string;
}

/** Sends the visitor to another path, carrying the query string over so an old link keeps its filters. */
export function RedirectKeepingSearch({ to }: RedirectKeepingSearchProps) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}
